import { render, staticRenderFns } from "./QrKpiCard.vue?vue&type=template&id=2bd383ce&scoped=true"
import script from "./QrKpiCard.vue?vue&type=script&lang=js"
export * from "./QrKpiCard.vue?vue&type=script&lang=js"
import style0 from "./QrKpiCard.vue?vue&type=style&index=0&id=2bd383ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd383ce",
  null
  
)

export default component.exports